module.exports = __webpack_public_path__ + "img/logo-search.e8ae0d9b.webp";